import ApolloClient from 'apollo-client'
import { Calculation } from 'final-form-calculate'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { createNovoAtendimentoCalculations } from 'view/atendimentos/calculator'
import { createDesfechoIndividualCalculations } from 'view/atendimentos/detail/soap/desfecho/calculator/calculatorIndividual'
import { createDesfechoOdontoCalculations } from 'view/atendimentos/detail/soap/desfecho/calculator/calculatorOdonto'

import { ProcedimentosAutomaticos } from '../../../atendimento-individual/AtendimentoIndividualView'

export const createDesfechoCalculations = (
  apollo: ApolloClient<object>,
  isMedico: boolean,
  procedimentosAutomaticos: ProcedimentosAutomaticos,
  tipoAtendProf: TipoAtendimentoProfissional
): Calculation[] => {
  const calculatorByTipoAtendProf: Calculation[] =
    tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO
      ? createDesfechoOdontoCalculations(procedimentosAutomaticos)
      : createDesfechoIndividualCalculations(procedimentosAutomaticos, isMedico)
  return [...createNovoAtendimentoCalculations(apollo), ...calculatorByTipoAtendProf]
}
